import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { APP_DOMAIN } from '../../models/app-domain.token';

@Component({
  selector: 'metall-rechner-privacy-policy',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent {
  private domain = inject(APP_DOMAIN);

  datenschutzEmail = `datenschutz@${this.domain}`;
  impressumUrl = `https://www.${this.domain}/impressum`;
}
